import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EnrollmentDate {
  id: number;
  employer_name: string;
  enrollment_start_date: string;
  enrollment_end_date: string;
  year: string;
  process_state: string; 
}

interface EnrollmentState {
  enrollments: EnrollmentDate[];
  loading: boolean;
  error: string | null;
}

const initialState: EnrollmentState = {
  enrollments: [],
  loading: false,
  error: null
};

const enrollmentSlice = createSlice({
  name: 'enrollment',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      state.error = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    setEnrollments: (state, action: PayloadAction<EnrollmentDate[]>) => {
      state.enrollments = action.payload;
      state.loading = false;
      state.error = null;
    },
    addEnrollment: (state, action: PayloadAction<EnrollmentDate>) => {
      state.enrollments.push(action.payload);
      state.loading = false;
      state.error = null;
    },
    clearEnrollments: (state) => {
      state.enrollments = [];
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  setLoading,
  setError,
  setEnrollments,
  addEnrollment,
  clearEnrollments
} = enrollmentSlice.actions;

export default enrollmentSlice.reducer; 